import React from "react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";


function QF_CuttingEdge()
{
    return (
        <div>
            <Helmet>
                <title>Cutting-Edge project | QF | Lucas RODRIGUEZ</title>
            </Helmet>
            <p className="small"><i className="fa fa-arrow-left"></i>&nbsp; <NavLink to="/qf">Go back to M2QF home</NavLink></p>

            <h2>Cutting-Edge project</h2>

            <p>
                <i>
                    This academic project aims at studying and implementending several ESGs (Economic Scenario Generators) for:
                    <ul>
                        <li>Equity models (Black-Scholes & Heston)</li>
                        <li>Interest rates models (Vasicek, CIR & Hull-White)</li>
                    </ul>
                    An in-depth study of parameter impacts over statistical distribution, derivatives pricing & trajectories shape are also conducted for multiple combinations of equity + rates models.
                </i>
            </p>

            <hr class="col-3 col-md-4 mb-4" />

            <a style={{ width: "200px" }} href="https://github.com/lcsrodriguez/CuttingEdge-Milliman" target="_BLANK" className="btn btn-dark">GitHub repository</a> <br /><br />
            <a style={{ width: "200px" }} href="https://lcsrodriguez.github.io/qf/cutting-edge/doc/" target="_BLANK" className="btn btn-warning">Documentation</a> <br /><br />
            <a style={{ width: "200px" }} href="https://github.com/lcsrodriguez/CuttingEdge-Milliman/raw/main/docs/deliverables/report.pdf" target="_BLANK" className="btn btn-warning">Report (PDF)</a> <br /><br />
            <a style={{ width: "200px" }} href="https://github.com/lcsrodriguez/CuttingEdge-Milliman/raw/main/docs/deliverables/slides.pdf" target="_BLANK" className="btn btn-warning">Slides (PDF)</a> <br /><br />

            <p className="text-muted small">
                <b>Authors</b>: Amal BACHA, Dalia BARBI, Khalil BATTIKH, Lucas RODRIGUEZ, Naïm SOUNI
            </p>
            <hr class="col-3 col-md-4 mb-4" />
            <p className="text-muted small">
                Work under license
            </p>
        </div >
    );
}

export default QF_CuttingEdge;